<template>
    <rkm-modal
        extraLarge
        ref="RkmModal"
        title="Listagem de pacientes"
        :buttons="['cancel']"
    >
        <rkm-row>
            <rkm-col>

                <List
                    :item="item"
                    @exit="exit"
                    origem="coleta"
                />
            </rkm-col>
        </rkm-row>
    </rkm-modal>
</template>

<script>

import List from '@/components/exame-laboratorial/agendamento-exame/List'

export default {
    components: { List },
    data: () => ({
        item: null
    }),
    methods: {
        open() {

            this.$refs.RkmModal.show()
        },
        exit() {

            this.$refs.RkmModal.hide()
        },
        handleCancel() {

            this.resetForm()
            this.$refs.RkmModal.hide()
        },
    },
}
</script>

